import { ComponentLibrary } from '@suntex.classic/adobe-animate';
import { UIUtil } from '@suntex.core/animation';

export class Label extends createjs.Container {
  constructor(lib: ComponentLibrary, labelName: string, frame: number = 1) {
    super();
    const labelObj = UIUtil.createDisplayObject(lib, labelName);
    this.addChild(labelObj);
    UIUtil.setFrame(labelObj, frame);
  }

  onHover({ animationMs }: { animationMs: number }) {
    UIUtil.tween(this, 'alpha', 1.0, animationMs, 'strongOut');
  }

  onLeave({
    animationMs,
    alwaysShow,
  }: {
    animationMs: number;
    alwaysShow: boolean;
  }) {
    if (!alwaysShow) {
      UIUtil.tween(this, 'alpha', 0.0, animationMs, 'strongIn');
    }
  }
}
